'use memo'

import {
  DisplayElement,
  filterDisplayElementHideCondition,
} from '@urbanx/agx-ui-components'
import { AppFeatures } from '@urbanx/agx.agencies.client'
import { CampaignDetailModel, FormPage } from '@urbanx/agx.campaigns.client'
import { AgxPanel, AgxSpacer } from '@urbanx/agx.ui-components2'
import { useMemo } from 'react'
import slugify from 'slugify'
import { FormValue, FormValueType } from 'types/formConfig'
import elementRenderer from 'utils/elementRenderer'

interface PanelElementRendererProps {
  panel: FormPage
  formValues: FormValue
  getAuthToken: () => Promise<string>
  onChange: (change: {
    id: string
    value: FormValueType[keyof FormValueType]
  }) => void
  campaign: CampaignDetailModel
  validate: boolean
  featureToggles?: AppFeatures
  featureTogglesLoading: boolean
}

const PanelElementRenderer = ({
  panel,
  formValues,
  getAuthToken,
  onChange,
  campaign,
  validate,
  featureToggles,
  featureTogglesLoading,
}: PanelElementRendererProps) => {
  const slugifiedPanelName = useMemo(() => {
    return slugify(panel.name ?? '')
  }, [panel?.name])

  const elements = useMemo(() => {
    return filterDisplayElementHideCondition(
      (panel?.elements ?? []) as unknown as DisplayElement[],
      formValues
    )
  }, [panel?.elements, formValues])

  const renderedElements =
    panel.elements &&
    elementRenderer({
      elements: elements,
      onChange,
      campaign,
      getAuthToken,
      formValues,
      validate,
      featureToggles,
      featureTogglesLoading,
    })

  if (panel.hideFormPageName) {
    return (
      <AgxSpacer
        direction="vertical"
        gap="lg"
        key={slugifiedPanelName}
        id={slugifiedPanelName}
      >
        {renderedElements}
      </AgxSpacer>
    )
  }

  return (
    <AgxPanel
      key={slugifiedPanelName}
      id={slugifiedPanelName}
      header={panel.name}
    >
      {renderedElements}
    </AgxPanel>
  )
}

export default PanelElementRenderer
